import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { Typography } from "@mui/material";
import { useQuery } from "@tanstack/react-query";

import { customerActions } from "../../../../reducers/customer";
import { APIAgentActivityLog } from "../../../../api";
import usePagination from "../../../../hooks/usePagination";
import { ISortBy } from "../../../../types";
import LogsHistoryTable from "../../../../components/ui/LogsHistoryTable";
import { AGENT_ACTIVITY_LOG_API_URLS } from "../../../../api/agentActivityLog";
import { ActiveFilter } from "../../../../components/ui/FilterSearch";

const CustomerHistoryLogs = (): React.ReactElement => {
  const dispatch = useDispatch();
  const params: { id: string } = useParams();
  const id = +params.id;
  const pagination = usePagination();

  const [activeFilters, setActiveFilters] = useState<Record<string, ActiveFilter>>({});
  const [sortBy, setSortBy] = useState<ISortBy>({ by: "log_time", order: false });

  const { loading, data } = useSelector((state) => state.customer.agentLogs);
  const { isError, error } = useQuery({
    queryKey: [
      AGENT_ACTIVITY_LOG_API_URLS.getCustomerLogs,
      id,
      pagination.limit,
      pagination.page,
      sortBy,
      activeFilters,
    ],
    queryFn: async ({ signal }) => {
      dispatch(customerActions.fetchAgentLogsRequest());
      const { data } = await APIAgentActivityLog.getCustomerLogsRequest(
        {
          limit: pagination.limit,
          page: pagination.page,
          sortBy,
          accounts_id: +id,
          activeFilters,
        },
        signal
      );
      dispatch(customerActions.fetchAgentLogsSuccess(data));
      pagination.setCount(data.count);
      return data;
    },
    refetchOnWindowFocus: false,
  });

  useEffect(() => {
    if (isError && error) {
      console.error("Error fetching agent logs", error);
      dispatch(customerActions.fetchAgentLogsFailed());
    }
  }, [isError, error]);

  return (
    <div>
      <Typography fontWeight={600}>Customer logs</Typography>
      <LogsHistoryTable
        count={data.count}
        logs={data.logs}
        loading={loading}
        pagination={pagination}
        handleSort={[sortBy, setSortBy]}
        setActiveFilters={setActiveFilters}
        filterOptions={[
          { key: "admin", label: "Agent" },
          { key: "code", label: "Code" },
          { key: "log_time", label: "Date", type: "date" },
        ]}
      />
    </div>
  );
};

export default CustomerHistoryLogs;
